import { createElementVNode as _createElementVNode, openBlock as _openBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("svg", {
  "aria-hidden": "true",
  focusable: "false",
  class: "h-4 w-4 mr-2",
  role: "img",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 384 512"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    fill: "currentColor",
    d: "M376 232H216V72c0-4.42-3.58-8-8-8h-32c-4.42 0-8 3.58-8 8v160H8c-4.42 0-8 3.58-8 8v32c0 4.42 3.58 8 8 8h160v160c0 4.42 3.58 8 8 8h32c4.42 0 8-3.58 8-8V280h160c4.42 0 8-3.58 8-8v-32c0-4.42-3.58-8-8-8z"
  })
], -1)
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Lisa administraator ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ButtonAdd = _resolveComponent("ButtonAdd")!
  const _component_AddAdministratorModal = _resolveComponent("AddAdministratorModal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_ButtonAdd, {
      class: "flex items-center",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.addAdministratorModal = true))
    }, {
      default: _withCtx(() => [
        _hoisted_1,
        _hoisted_2
      ]),
      _: 1
    }),
    (_ctx.addAdministratorModal)
      ? (_openBlock(), _createBlock(_component_AddAdministratorModal, {
          key: 0,
          onOnClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.addAdministratorModal = false))
        }))
      : _createCommentVNode("", true)
  ]))
}